// extracted by mini-css-extract-plugin
export default {"coverflow":"CoverFlow_coverflow__Qcx0U","coverflow__footer":"CoverFlow_coverflow__footer__B6FmP"};